import { useMemo } from 'react';
import AuthService from '../../service/auth';
import { ROLES } from '../../constnats/user';
import useModalState from '../../hooks/useModalState';
import { Chart } from '../chart';
import type { ChartDescriptor, ChartReport } from '../chart';

type TableChartProps = {
    companyId: number;
    schemaId: number;
    companyName: string;
    schemaName: string;
    ticker: string;
    companyTitle: string;
    descriptors: ChartDescriptor[];
    reports: ChartReport[];
    showOriginalDataIfLatestIsMissing?: boolean;
    descending?: boolean;
};

export default function TableChart({
    companyId,
    schemaId,
    companyName,
    schemaName,
    ticker,
    companyTitle,
    descriptors,
    reports,
    showOriginalDataIfLatestIsMissing,
    descending,
}: TableChartProps) {
    const downloadModal = useModalState();

    const dataSources = useMemo(() => [{
        id: companyId,
        label: companyTitle,
        companyId,
        companyName: companyTitle,
        schemaId,
        schemaName,
        descriptors,
        reports,
    }], [companyId, companyTitle, companyName, schemaId, schemaName, descriptors, reports]);

    return (
        <Chart.Provider
            dataSources={dataSources}
            showOriginalDataIfLatestIsMissing={showOriginalDataIfLatestIsMissing}
            descending={descending}
        >
            <Chart.Toolbar onDownloadClick={downloadModal.openModal} />
            <div className="flex">
                <Chart.FieldSidebar />
                <div className="generalChartWrapper">
                    {AuthService.hasAnyGlobalRole([ROLES.EMPLOYEE] as any) && (
                        <Chart.Heading />
                    )}
                    <Chart.Renderer />
                    <Chart.Legend />
                </div>
            </div>
            <Chart.DownloadModal open={downloadModal.open} onClose={downloadModal.closeModal} />
        </Chart.Provider>
    );
}
